import React from 'react'

export const L_card = (props) => {
  return (
    <div className='w-[100%]'>
                <div className="h-[150px] w-[100%] mt-5 border-2">
                <h5 className="px-5 mb-2 text-lg font-bold tracking-tight text-gray-700 dark:text-gray-700 mt-3">{props.heading} </h5>
                </div>
    </div>
  )
}


